import React from 'react';
import PropTypes from 'prop-types';
import colors from '../../customizations/js/color-variables';

import './loader.scss';

export const Loader = ({ size, color }) => (
  <div className="loading">
    <span
      className="dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: color,
      }}
    />
    <span
      className="dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: color,
      }}
    />
    <span
      className="dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: color,
      }}
    />
  </div>
);

Loader.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

Loader.defaultProps = {
  size: 8,
  color: colors.white,
};
